@switch (size()){
  @case('sm'){
    <p-progress-spinner [style]="{width: this.sizeString, height: this.sizeString}" ></p-progress-spinner>
  }
  @case ('md'){
    <p-progress-spinner [style]="{width: this.sizeString, height: this.sizeString}"></p-progress-spinner>
  }
  @case ('lg'){
    <p-progress-spinner [style]="{width: this.sizeString, height: this.sizeString}"></p-progress-spinner>
  }
  @default {
    <p-progress-spinner [style]="{width: this.sizeString, height: this.sizeString}"></p-progress-spinner>
  }
}
